// SERVICES
import Http from '../services/Http';

//public sector
export default class PageRepo{

    constructor($auth){
        this.http = new Http($auth);
        this.resource = 'page';
    }


    getCommentsData(route){
        return this.getPageData(route, 'me,categories,sentences,schools,nonStaticMagicWords,favoriteComments,historyComments,magicWords').then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    getProfileData(route){
/*        return this.getPageData(route, 'me,allSchools').then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });*/

        let data = {
            route: route,
        };
        return this.http.post(this.resource + "/profile", data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    getSentencesData(route){
        return this.getPageData(route, 'categories,sentences,magicWords').then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    getCategoriesData(route){
        return this.getPageData(route, 'categories').then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    getPageData(route, requestedItems){
        let data = {
            route: route,
            requestedItems: requestedItems,
            page:1,
            pagination:6,
            //include: 'sentences.categories'
        };
        return this.http.post(this.resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
}


// WEBPACK FOOTER //
// ./src/repos/PageRepo.js